import Quill from 'quill';

const Parent = Quill.import('formats/strike');

export class Strike extends Parent {
  static tagName = 'DEL';
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill/formats/strike/strike.format.ts